import * as React from 'react';
import './MessageDialog.css';
import { ApplicationState } from '../../store';
import * as MessageReducer from '../../store/MessageReducer';
import { connect } from 'react-redux';
import { MessageData } from '../../entities/SystemEntities';
import ModalView from "./ModalView";

// ------------------------------------------------------------------------------------------------
// component

type Props =
    typeof MessageReducer.actionCreators & {
        messageState: MessageReducer.MessageState;
}

interface State {
}

class MessageDialog extends React.PureComponent<Props, State> {

    // --------------------------------------------------------------------------------------------
    // state

    public state = {
    };

    // --------------------------------------------------------------------------------------------
    // actions

    onClickOk = () => {
        console.log("Click Ok");
        this.props.closeModal();
        let data: MessageData = this.props.messageState.data;
        if (data && data.onAction) {
            data.onAction("Ok", data.object);
        }
    }

    onClickCancel = () => {
        console.log("Click Cancel");
        this.props.closeModal();
        let data: MessageData = this.props.messageState.data;
        if (data && data.onAction) {
            data.onAction("Cancel", data.object);
        }
    }

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        let data: MessageData = this.props.messageState.data;
        let title: string = data ? data.title : "";
        let message: string = data ? data.message : "";

        let showButtons = data.type;
        let allowOk = data.type && data.type.indexOf("Ok") >= 0;
        let allowCancel = data.type && data.type.indexOf("Cancel") >= 0;
        let messageStyle = data.style ? "message-style-" + data.style : "";
        return (
            <ModalView>
                <div className="message-dialog">
                    <div className="message-dialog-title">
                        <span>{title}</span>
                    </div>
                    <div className="message-dialog-body">
                        <div className="message-dialog-message">
                            <span className={messageStyle}>{message}</span>
                        </div>
                        {showButtons ? (
                            <div className="message-dialog-buttons">
                                {allowOk ? (
                                    <button onClick={this.onClickOk}>Ok</button>
                                ) : null}
                                {allowCancel ? (
                                    <button onClick={this.onClickCancel}>Cancel</button>
                                ) : null}
                            </div>                           
                        ) : null}
                    </div>
                </div>
            </ModalView>
        );
    }
}

export default connect(
    (state: ApplicationState) => { return { messageState: state.messageState } },
    { ...MessageReducer.actionCreators }
)(MessageDialog as any);
